import React, { useEffect, useRef } from 'react'
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Icons from "../../myIcon/Icons";
import { Link } from 'react-router-dom';
import Slider from "react-slick";

export default function OurWorkGallery({ galleryData, handleShow }) {
  const sliderRef = useRef(null);

  useEffect(() => {

    let fb;

    if (typeof window !== "undefined") {

      import("@fancyapps/ui").then((mod) => {

        fb = mod.Fancybox;

        fb.bind("[data-fancybox='gallery']", {});
      });
    }

    return () => {
      if (fb) {
        fb.destroy();
      }
    };

  }, []);

  const gallerySettings = {
    autoplay: true,
    speed: 1500,
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },

      {
        breakpoint: 599,
        settings: { slidesToShow: 1, },
      },

      {
        breakpoint: 99999,
        settings: "unslick",
      },
    ],
  };

  const CustomArrows = () => (
    <>
      <div className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
        <Icons name="Longarrow_left" />
      </div>
      <div className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
        <Icons name="Longarrow_right" />
      </div>
    </>
  );

  return (
    <>
      <div className='workgallery-section'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <h5 className='heading'>A Glimpse of Our Work</h5>
              <p>Explore our curated collection of stunning kitchen designs</p>

              <div className='addland-gallery'>
                <Slider {...gallerySettings} className='addpage-gallery' ref={sliderRef}>
                  {galleryData.map((item, index) => (
                    <div className='workgallery-main' key={index}>
                      <a href={item.image} data-fancybox="gallery">
                        <img src={item.image} alt='gallery' className='img-responsive' />
                        <span><Icons name="expand" /> </span>
                      </a>
                    </div>
                  ))
                  }
                </Slider>
                <CustomArrows />
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12 text-center'>
              <div className="landgallery-more">
                <Link onClick={handleShow} className="default-btn colored-btn">
                  Consult Now
                  <Icons name="Longarrow_right" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}